import React from 'react';
// utils
// settings
// icons
// components
//
//
//
import StartColumnsContainer from 'modules/emergencies/components/ui/containers/startColumnsContainer';
//
//
import BodyRow from 'modules/emergencies/components/ui/rows/bodyRow';
import { NameColumn } from '../columns/NameColum';
import styled from 'styled-components';
import { ActionsColumn } from '../columns/ActionsColumn';

const CustomStartColumnsContainer = styled(StartColumnsContainer)`
  width: 500px;
  margin-left: auto;
  margin-right: auto;
`;
const CustomBodyRow = styled(BodyRow)`
  padding-top: 16px;
  padding-bottom: 16px;
`;

const FilterViewsListTableItemRow = ({ filterView }) => {
  return (
    <>
      <CustomBodyRow key={filterView.id}>
        <CustomStartColumnsContainer>
          <NameColumn filterView={filterView} />
          <ActionsColumn filterView={filterView} />
        </CustomStartColumnsContainer>
      </CustomBodyRow>
    </>
  );
};

export default FilterViewsListTableItemRow;
